import Vue from "vue";
import Router from "vue-router";
import store from "store";
import Store from "@/store/store";
import i18n from "@/i18n";

Vue.use(Router);

export const constantRoutes = [
    // {
    //   path: '/',
    //   name: 'Home',
    //   component: () => import('@/views/consumers/clients/sweepindex'),
    // },
    // { path: '/', redirect: '/sweep' },
    /*
     **授权页
     **
     */
    {
        path: "/author",
        component: () => import("@/views/author"),
    },
    /*
     **登录
     **
     */
    {
        path: "/login",
        name: "智能充电",
        component: () => import("@/views/login/index"),
    },
    /*
     **404
     **
     */
    {
        path: "/404",
        component: () => import("@/views/error-page/404"),
    },
    /*
     **401
     **
     */
    {
        path: "/401",
        name: '401',
        component: () => import("@/views/error-page/401"),
    },
    /*
     ** 运营端
     **
     */
    {
        path: "/",
        name: "Admin",
        redirect: "/admin/equipment",
        component: () => import("@/views/operations/admin"),
        children: [
            /*
             ** 主页
             **
             */
            {
                path: "/admin/index",
                name: "AdminIndex",
                meta: { titleKey: "admin.admin_3" },
                component: () => import("@/views/operations/mine/index"),
            },
            /*
             ** 经营管理
             **
             */
            {
                path: "/admin/equipment",
                name: "AdminEquipment",
                meta: { titleKey: "admin.admin_1" },
                // component: () => import('@/views/operations/equipment/equipment'),
                component: () => import("@/views/operations/mine/dataView"),
            },
            /*
             ** 分成明细
             **
             */
             {
                path: "/admin/dividerDetail",
                //name: "分成明细",
                meta: { titleKey: "admin.admin_5" },
                // component: () => import('@/views/operations/equipment/equipment'),
                component: () => import("@/views/operations/mine/dividerDetail"),
            },
            /*
             **账单明细
             **
             */
            {
                path: "/admin/bil",
                name: "Bil",
                component: () => import("@/views/operations/equipment/bil"),
            },
            /*
             **地址统计
             **
             */
            {
                path: "/admin/address",
                name: "Address",
                component: () => import("@/views/operations/equipment/address"),
            },
            /*
             **时间统计
             **
             */
            {
                path: "/admin/time",
                name: "Time",
                component: () => import("@/views/operations/equipment/time"),
            },

            /*
             **订单管理
             **
             */
            {
                path: "/admin/orderFour",
                //name: "订单列表",
                meta: { titleKey: "admin.admin_6" },
                component: () => import("@/views/operations/order/four/order"),
            },
            {
                path: "/admin/orderTwo",
                //name: "订单列表",
                meta: { titleKey: "admin.admin_6" },
                component: () => import("@/views/operations/order/two/order"),
            },
            {
                path: "/admin/orderDetailFour",
                //name: "订单详情",
                meta: { titleKey: "admin.admin_7" },
                component: () => import("@/views/operations/order/four/orderDetail"),
            },
            {
                path: "/admin/orderDetailTwo",
                //name: "订单详情",
                meta: { titleKey: "admin.admin_7" },
                component: () => import("@/views/operations/order/two/orderDetail"),
            },
            {
                path: "/admin/orderBackMoneyFour",
                //name: "退款",
                meta: { titleKey: "admin.admin_8" },
                component: () => import("@/views/operations/order/four/orderBackMoney"),
            },
            {
                path: "/admin/orderBackMoneyTwo",
                //name: "退款",
                meta: { titleKey: "admin.admin_8" },
                component: () => import("@/views/operations/order/two/orderBackMoney"),
            },
            {
                path: "/admin/portChangeFour",
                //name: "订单编辑",
                meta: { titleKey: "admin.admin_9" },
                component: () => import("@/views/operations/order/four/portChange"),
            },
            {
                path: "/admin/portChangeTwo",
                //name: "订单编辑",
               meta: { titleKey: "admin.admin_9" },
                component: () => import("@/views/operations/order/two/portChange"),
            },
            /*
             **订单统计管理
             **
             */
            {
                path: "/admin/ordersalesFour",
                //name: "查看收益",
                meta: { titleKey: "admin.admin_10" },
                component: () => import("@/views/operations/order/four/ordersales"),
            },
            {
                path: "/admin/ordersalesTwo",
                //name: "查看收益",
                meta: { titleKey: "admin.admin_10" },
                component: () => import("@/views/operations/order/two/ordersales"),
            },

            /*
             **卡管理
             **
             */
            {
                path: "/admin/cardFour",
                //name: "卡管理",
                meta: { titleKey: "admin.admin_11" },
                component: () => import("@/views/operations/card/four/card"),
            },
            {
                path: "/admin/cardTwo",
                //name: "卡管理",
                meta: { titleKey: "admin.admin_11" },
                component: () => import("@/views/operations/card/two/card"),
            },
            /*
             **卡充值记录
             **
             */
            {
                path: "/admin/cardinvestFour/:id",
                //name: "卡充值记录",
                meta: { titleKey: "admin.admin_12" },
                component: () => import("@/views/operations/card/four/cardinvest"),
            },
            {
                path: "/admin/cardinvestTwo/:id",
                //name: "卡充值记录",
                meta: { titleKey: "admin.admin_12" },
                component: () => import("@/views/operations/card/two/cardinvest"),
            },
            /*
             **卡使用记录
             **
             */
            {
                path: "/admin/carduseFour/:id",
                //name: "卡使用记录",
                meta: { titleKey: "admin.admin_13" },
                component: () => import("@/views/operations/card/four/carduse"),
            },
            {
                path: "/admin/carduseTwo/:id",
                //name: "卡使用记录",
                meta: { titleKey: "admin.admin_13" },
                component: () => import("@/views/operations/card/two/carduse"),
            },
            /*
             **反馈管理
             **
             */
            {
                path: "/admin/response",
                //name: "反馈管理",
                meta: { titleKey: "admin.admin_14" },
                component: () => import("@/views/operations/response/response"),
            },
            /*
             **反馈详情
             **
             */
            {
                path: "/admin/response-single/:id",
                name: "反馈详情",
                meta: { titleKey: "admin.admin_15" },
                component: () => import("@/views/operations/response/response-single"),
            },
            /*
             **我的
             **
             */
            {
                path: "/admin/mine",
                name: "Mine",
                meta: { titleKey: "admin.admin_2" },
                component: () => import("@/views/operations/mine/mine"),
            },
            /*
             **余额详情
             **
             */
            {
                path: "/admin/balance",
                //name: "余额详情",
                meta: { titleKey: "admin.admin_16" },
                component: () => import("@/views/operations/mine/balance"),
            },
            {
                path: "/admin/bind_wechat",
                //name: "绑定微信",
                meta: { titleKey: "admin.admin_17" },
                component: () => import("@/views/operations/mine/bind_wechat"),
            },
            /*
             **账号设置
             **
             */
            {
                path: "/admin/setting",
                //name: "账号设置",
                meta: { titleKey: "admin.admin_18" },
                component: () => import("@/views/operations/mine/setting"),
            },
            {
                path: "/admin/language",
                //name: "语言",
                meta: { titleKey: "locale.label" },
                meta: { titleKey: "admin.admin_19" },
                component: () => import("@/views/operations/mine/language"),
            },
            /*
             **提现记录
             **
             */
            {
                path: "/admin/drawcash",
                //name: "提现记录",
                meta: { titleKey: "admin.admin_20" },
                component: () => import("@/views/operations/mine/drawcash"),
            },
            /*
             **设备管理
             **
             */
            {
                path: "/admin/equipFour",
                //name: "设备管理",
                meta: { titleKey: "admin.admin_21" },
                component: () => import("@/views/operations/equip/four/equip"),
            },
            {
                path: "/admin/equipTwo",
                //name: "设备管理",
                meta: { titleKey: "admin.admin_21" },
                component: () => import("@/views/operations/equip/two/equip"),
            },
            /*
             **设备编辑
             **
             */
            {
                path: "/admin/equipaddFour/:id",
                //name: "设备编辑",
                meta: { titleKey: "admin.admin_22" },
                component: () => import("@/views/operations/equip/four/equipadd"),
            },
            {
                path: "/admin/equipaddTwo/:id",
                //name: "设备编辑",
                meta: { titleKey: "admin.admin_22" },
                component: () => import("@/views/operations/equip/two/equipadd"),
            },
            /*
             **设备添加
             **
             */
            {
                path: "/admin/equipaddFour",
                //name: "设备添加",
                meta: { titleKey: "admin.admin_23" },
                component: () => import("@/views/operations/equip/four/equipadd"),
            },
            {
                path: "/admin/portFour/:id",
                //name: "设备端口",
                meta: { titleKey: "admin.admin_24" },
                component: () => import("@/views/operations/equip/four/port"),
            },
            {
                path: "/admin/equipaddTwo",
                //name: "设备添加",
                meta: { titleKey: "admin.admin_23" },
                component: () => import("@/views/operations/equip/two/equipadd"),
            },
            {
                path: "/admin/portTwo/:id",
                //name: "设备端口",
                meta: { titleKey: "admin.admin_24" },
                component: () => import("@/views/operations/equip/two/port"),
            },
            /*
             **用户管理
             **
             */
            {
                path: "/admin/users",
                //name: "用户管理",
                meta: { titleKey: "admin.admin_25" },
                component: () => import("@/views/operations/mine/users"),
            },
            /*
             **用户管理
             **
             */
            {
                path: "/admin/transferAccounts",
                //name: "转账",
                meta: { titleKey: "admin.admin_26" },
                component: () => import("@/views/operations/mine/transferAccounts"),
            },
            /*
             **规则管理
             **
             */
            {
                path: "/admin/rulesFour",
                //name: "规则管理",
                meta: { titleKey: "admin.admin_27" },
                component: () => import("@/views/operations/rules/four/rules"),
            },
            {
                path: "/admin/rulesTwo",
                //name: "规则管理",
                meta: { titleKey: "admin.admin_27" },
                component: () => import("@/views/operations/rules/two/rules"),
            },
            {
                path: "/admin/rules-select",
                //name: "选择规则",
                meta: { titleKey: "admin.admin_28" },
                component: () => import("@/views/operations/rules/four/select"),
            },
            /*
             **规则编辑
             **
             */
            {
                path: "/admin/editruleFour",
                //name: "规则编辑",
                meta: { titleKey: "admin.admin_29" },
                component: () => import("@/views/operations/rules/four/editrule"),
            },
            {
                path: "/admin/editruleTwo",
                //name: "规则编辑",
                meta: { titleKey: "admin.admin_29" },
                component: () => import("@/views/operations/rules/two/editrule"),
            },
            // {
            //   path: '/admin/editrule2/:id',
            //   name: 'Editrule',
            //   component: () => import('@/views/operations/rules/editrule2'),
            // },
            {
                path: "/admin/siteFour",
               // name: "站点管理",
                meta: { titleKey: "admin.admin_30" },
                component: () => import("@/views/operations/site/four/index.vue"),
            },
            {
                path: "/admin/siteTwo",
                //name: "小区管理",
                 meta: { titleKey: "admin.admin_31" },
                component: () => import("@/views/operations/site/two/index.vue"),
            },
            {
                path: "/admin/addSiteFour",
                //name: "站点新增/编辑",
                 meta: { titleKey: "admin.admin_32" },
                component: () => import("@/views/operations/site/four/addSite.vue"),
            },
            {
                path: "/admin/addSiteTwo",
                //name: "站点新增/编辑",
                 meta: { titleKey: "admin.admin_32" },
                component: () => import("@/views/operations/site/two/addSite.vue"),
            },
            {
                path: "/admin/advert",
                //name: "广告管理",
                 meta: { titleKey: "admin.admin_33" },
                component: () => import("@/views/operations/advert/index.vue"),
            },
            {
                path: "/admin/addAdvert",
                //name: "广告新增/编辑",
                 meta: { titleKey: "admin.admin_34" },
                component: () => import("@/views/operations/advert/addAdvert.vue"),
            },
            {
                path: "/admin/promotion",
                //name: "促销管理",
                 meta: { titleKey: "admin.admin_35" },
                component: () => import("@/views/operations/promotion/index.vue"),
            },
            {
                path: "/admin/addPromotion",
                //name: "促销新增/编辑",
                 meta: { titleKey: "admin.admin_36" },
                component: () =>
                    import("@/views/operations/promotion/addPromotion.vue"),
            },
            {
                path: "/admin/tixian",
                //name: "提现",
                 meta: { titleKey: "admin.admin_37" },
                component: () => import("@/views/operations/mine/tixian.vue"),
            },
            {
                path: "/admin/userInvest/:id",
                //name: "用户充值记录",
                 meta: { titleKey: "admin.admin_38" },
                component: () => import("@/views/operations/mine/userInvest.vue"),
            },
            {
                path: "/admin/addCardFour",
                //name: "卡新增/编辑",
                 meta: { titleKey: "admin.admin_39" },
                component: () => import("@/views/operations/card/four/addCard.vue"),
            },
            {
                path: "/admin/addCardTwo",
                //name: "卡新增/编辑",
                 meta: { titleKey: "admin.admin_39" },
                component: () => import("@/views/operations/card/two/addCard.vue"),
            },
            {
                path: "/admin/responseDetail",
                //name: "问题详情",
                 meta: { titleKey: "admin.admin_40" },
                component: () =>
                    import("@/views/operations/response/responseDetail.vue"),
            },

            {
                path: "/admin/policy",
                //name: "用户协议",
                 meta: { titleKey: "admin.admin_41" },
                component: () => import("@/views/operations/mine/policy.vue"),
            },
            {
                path: "/admin/royalty",
                //name: "分成汇总",
                 meta: { titleKey: "admin.admin_42" },
                component: () =>
                    import("@/views/operations/mine/royalty.vue"),
            },
        ],
    },
];

const createRouter = () =>
    new Router({
        // mode: 'history', // require service support
        scrollBehavior: () => ({y: 0}),
        routes: constantRoutes,
    });

const router = createRouter();
// 从这到 -》》》》》》》》》》
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});
// 全局路由拦截-进入页面前执行
let isRedirectingTo401 = false; // 新增标志位
router.beforeEach((to, from, next) => {
    try {
        // 保存用户进入的url
        store.set("fullUrl", { name: to.fullPath }); 
        store.set("latestUrl", { name: location.href });

        // 检查 window.navigator 是否存在
        if (window && window.navigator) {
            const ua = window.navigator.userAgent?.toLowerCase() || '';
            const isWechat = /micromessenger/i.test(ua);

            if (isWechat || true) {
                // 确保 to.name 存在时再设置标题
                if (to.meta && to.meta.titleKey) {
                    document.title = i18n.t(to.meta.titleKey);
                } else if (to.name) {
                    document.title = to.name;
                }
                const token = window.localStorage?.getItem("token") || '';
                const allowedPaths = ["/login", "/admin/policy"];

                if (token || allowedPaths.includes(to.path)) {
                    next();
                } else {
                    next("/login");
                }
            } else {
                // 避免重复跳转到 401 页面
                if (!isRedirectingTo401 && (!from.name || from.name !== '401')) {
                    isRedirectingTo401 = true;
                    next('/401');
                    // 跳转完成后重置标志位
                    setTimeout(() => {
                        isRedirectingTo401 = false;
                    }, 0);
                } else {
                    next();
                }
            }
        } else {
            // 处理 window.navigator 不存在的情况
            next('/401');
        }
    } catch (error) {
        // 捕获并处理可能出现的异常
        console.error('路由拦截过程中出现错误:', error);
        next('/401');
    }
});

export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

// 《《《《《《-------从这打开
export default router;
